import React from 'react'
import 'styles/StyledScrollbars.css'

export default function StyledScrollbars ({ className = '', ...props }) {
  return (
    <div className={`StyledScrollbars ${className}`} {...props} />
  )
}
